window.screwBuilder = data => ({
    currentStep: 0,
    steps: [],
    success: true,
    build: {},
    enquiry: {},
    buttonHeld: false,
    heldTimeout: null,
    minimum: 1,
    started: false,
    saving: false,

    async init() {
        this.steps = JSON.parse(decodeURIComponent(data.steps)).map((step, index) => ({
            ...step,
            visited: index === 0,
            active: index === 0
        }));
        this.field_groups = JSON.parse(decodeURIComponent(data.field_groups))
        this.fields = JSON.parse(decodeURIComponent(data.fields))
        this.build = JSON.parse(decodeURIComponent(data.build || '{}'))

        const searchParams = new URLSearchParams(window.location.search)
        const buildId = searchParams.get('build_id')
        if (buildId) {
            await this.getBuild(buildId)
        }

        const countryId = window.Alpine.store('user').delivery_country_id
        if (countryId) {
            this.fields.delivery_country_id.value = countryId
        }
        if (window.Alpine.store('user').isLoggedIn) {
            this.fields.email.value = window.Alpine.store('user').email
            this.fields.company_name.value = window.Alpine.store('user').company
        }

        this.filterAvailableFields()
    },
    start() {
        if (!this.started) {
            window.dispatchEvent(new CustomEvent('gtmdata', {
                detail: {
                    event: 'gtm_screw_builder_start',
                }
            }))
            this.started = true
        }
    },
    filterAvailableFields() {
        for (let fieldId in this.fields) {
            const field = this.fields[fieldId];

            if (
                !field.options &&
                !field.requiredOptions &&
                !field.optionalOptions
            ) {
                field.active = true;
            }

            for (let optionId in field.options) {
                const option = field.options[optionId];

                if (!option.requiredOptions) {
                    option.active = true;
                    continue;
                }

                for (let requiredOption in option.requiredOptions) {
                    const active = option.requiredOptions[
                        requiredOption
                    ].includes(this.fields[requiredOption].value);
                    option.active = active;

                    if (!active && field.value == optionId) {
                        field.value = null;
                    }
                }
            }

            let active = false;
            let changeActive = false;

            for (let requiredOption in field.requiredOptions) {
                active = field.requiredOptions[requiredOption].includes(
                    this.fields[requiredOption].value
                );
                changeActive = true;
            }

            for (let optionalOption in field.optionalOptions) {
                const optionalActive = field.optionalOptions[
                    optionalOption
                ].includes(this.fields[optionalOption].value);
                field.optional = optionalActive;
                changeActive = true;

                if (optionalActive) {
                    active = true;
                }
            }

            if (changeActive) {
                field.active = active;
            }

            // --- Custom default for countersunk_angle when unit is metric ---
            if (fieldId === 'countersunk_angle' && field.active) {
                if (this.fields.unit && this.fields.unit.value === 'metric') {
                    if (!field.userModified && (!field.value || field.value !== '90')) {
                        field.value = '90';
                    }
                } else if (!field.userModified) {
                    // If not metric, reset to default if not user-modified
                    if (field.default && field.value !== field.default) {
                        field.value = field.default;
                    }
                }
                continue;
            }

            if (!field.userModified) {
                if (field.active) {
                    if (field.defaults) {
                        let defaultValue = null;

                        for (let targetField in field.defaults) {
                            const defaultValues = field.defaults[targetField];
                            const sourceValue = this.fields[targetField].value;

                            if (sourceValue && defaultValues[sourceValue]) {
                                defaultValue = defaultValues[sourceValue];
                                break;
                            }
                        }

                        if (!defaultValue && field.default) {
                            defaultValue = field.default;
                        }

                        if (defaultValue) {
                            field.value = defaultValue;
                        }
                    }
                    else if (field.default && !field.value) {
                        field.value = field.default;
                    }
                }
            }
        }

        this.calculateImages();

        this.steps.forEach((step, index) => {
            if (index === this.steps.length - 1) return;

            const nextStep = this.steps[index + 1];
            const isCurrentStepComplete = step.fields?.every(
                field =>
                    (step.field_groups && !this.fields[field].default && !this.fields[field].defaults) ||
                    (!this.fields[field].error &&
                        (this.fields[field].optional ||
                            this.fields[field].value)) ||
                    !this.fields[field].options &&
                    !this.fields[field].active
            );
            nextStep.active = nextStep.visited || (isCurrentStepComplete && this.currentStep === index);
        });
    },
    calculateImages() {
        if (!this.fields.head.value) {
            this.fields.head.calculated_image = Object.values(this.fields.head.options)[0].image
        }
        if (!this.fields.body.value) {
            this.fields.body.calculated_image = Object.values(this.fields.body.options)[0].image
        }

        if (this.fields.head.value) {
            for (let option in this.fields.drive.options) {
                const images =
                    this.fields.head.options[this.fields.head.value].images?.[
                    option
                    ]
                const image =
                    images?.[this.fields.finish.value] ||
                    images?.[this.fields.material.value] ||
                    images?.['default']

                this.fields.drive.options[option].calculated_image = image

                if (this.fields.drive.value == option || (!this.fields.drive.value && Object.keys(this.fields.head.options[this.fields.head.value].images)[0] == option)) {
                    this.fields.drive.calculated_image = image
                    this.fields.head.calculated_image = image
                }
            }
        }

        for (let option in this.fields.body.options) {
            const image =
                this.fields.body.options[option].images?.[
                this.fields.finish.value
                ] || this.fields.body.options[option].image
            this.fields.body.options[option].calculated_image = image
            if (this.fields.body.value == option) {
                this.fields.body.calculated_image = image
            }
            if (
                !this.fields.body.value &&
                this.fields.body.options[option].active
            ) {
                this.fields.body.calculated_image = image
                break
            }
        }

        if (this.fields.material.value) {
            const image =
                this.fields.material.options[this.fields.material.value]?.image
            this.fields.finish.options.natural.calculated_image = image
        }

        for (let fieldGroup in this.field_groups) {
            for (let field of this.field_groups[fieldGroup].fields) {
                const imageMap = {
                    head: 'drive',
                    thread: 'body',
                    drive: 'drive',
                    body: 'body',
                }

                const imageField = imageMap[fieldGroup]

                this.fields[field].calculated_image =
                    this.fields[imageField].calculated_image ||
                    this.fields[imageField].options?.[
                        this.fields[imageField].value
                    ]?.image ||
                    this.fields[imageField].image
            }
        }
        this.fields['thread_size'].calculated_image = this.fields['body'].calculated_image
    },
    confirmEdit(field, step, confirmed = false) {
        if (this.$store.general.pendingEdit) {
            const { field: pendingField, targetStep } = this.$store.general.pendingEdit;
            this.setStep(targetStep);
            this.$store.general.showOverlay = false;
            this.$store.general.showScrewBuilderEditConfirmation = false;
            this.$store.general.pendingEdit = null;
            this.$store.general.warningShownOnce = true;

            // Scroll to field after navigation
            setTimeout(() => {
                const element =
                    document.querySelector(`[id="error-${pendingField}"]`) ||
                    document.querySelector(`[name="${pendingField}"]`)
                element?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                })
            }, 100);
            return;
        }

        if (step === 7) {
            this.setStep(this.steps.indexOf(this.steps.find((step) => step.fields?.includes(field))))
            this.$store.general.warningShownOnce = true;
            return
        }
        const nextStepFields = this.steps[step + 1].fields
        let requiresConfirmation = false
        const fieldStep = this.steps.findIndex((step) => step.fields?.includes(field))
        for (let field of nextStepFields) {
            if (this.fields[field].value) {
                requiresConfirmation = true
                break
            }
        }
        if (!requiresConfirmation || confirmed || step > 2 || this.$store.general.warningShownOnce) {
            this.fields[field].value = this.fields[field].tempValue;
            this.fields[field].tempValue = null;
            this.$store.general.showOverlay = false;
            this.$store.general.showScrewBuilderEditConfirmation = false;
        } else {
            this.$store.general.showScrewBuilderEditConfirmation = true;
            this.$store.general.showOverlay = true;
            this.$store.general.warningShownOnce = true;
        }
        this.calculateImages()
        this.filterAvailableFields()
    },
    selectOption(field, option, start = true) {
        if (start) {
            this.start()
        }

        // Store the previous finish value before filtering
        const previousFinish = this.fields.finish.value;

        // Apply the selection and filter available options
        this.fields[field].value = option;

        // If the unit is being changed, reset userModified for countersunk_angle so default can be reapplied
        if (field === 'unit' && this.fields.countersunk_angle) {
            this.fields.countersunk_angle.userModified = false;
        }

        this.filterAvailableFields();

        // Special handling for material selection affecting finish
        if (field === 'material') {
            const finishField = this.fields.finish;
            const selectedFinishOption = finishField.options[previousFinish];

            // Check if the previously selected finish is now inactive
            if (selectedFinishOption && !selectedFinishOption.active) {
                // Reset to default finish if previous selection is no longer valid
                finishField.value = finishField.default;
                this.filterAvailableFields(); // Refilter to apply the default
            }
        }

        // if you select a material, scroll the finish options into view
        setTimeout(() => {
            const finish = document.getElementById('finish')
            if (finish) {
                finish.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'nearest' 
                })
            }
        }, 300) // 300ms delay for a smoother transition

        window.dispatchEvent(new CustomEvent('gtmdata', {
            detail: {
                event: 'gtm_screw_builder_option_selected',
                payload: {
                    field: field,
                    option: option,
                    currentStep: this.currentStep,
                }
            },
        }))
    },
    inputField(field, value) {
        this.fields[field].userModified = true
        if (this.fields[field].validation == 'fraction') {
            const decimal = this.parseFraction(value)

            if (typeof decimal != 'number') {
                this.fields[field].error = 'Must be a valid decimal or fraction'
            } else {
                this.fields[field].error = null
            }
        } else if (this.fields[field].validation == 'number') {
            if (!this.isNumber(value)) {
                this.fields[field].error = 'Must be a valid number'
            } else if (value < this.fields[field].min) {
                this.fields[field].error =
                    'Must be at least ' + this.fields[field].min
            } else if (value > this.fields[field].max) {
                this.fields[field].error =
                    'Cannot be more than ' + this.fields[field].max
            } else {
                this.fields[field].error = null
            }
        } else if (this.fields[field].validation == 'email') {
            if (!this.isEmail(value)) {
                this.fields[field].error = 'Must be a valid email'
            } else {
                this.fields[field].error = null
            }
        } else if (this.fields[field].validation == 'phone') {
            if (!this.isPhone(value)) {
                this.fields[field].error = 'Must be a valid phone number'
            } else {
                this.fields[field].error = null
            }
        } else {
            this.fields[field].error = null
        }

        if (this.fields[field].optional && !value) {
            this.fields[field].error = null
        }

        this.filterAvailableFields()
    },
    isEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    },
    isPhone(value) {
        return /^\+?\d{7,}$/.test(value);
    },

    editField(field) {
        // Check if we're in the summary step (step 7) and should show confirmation
        if (this.currentStep === 7 && !this.$store.general.warningShownOnce) {
            this.$store.general.showScrewBuilderEditConfirmation = true;
            this.$store.general.showOverlay = true;

            // Store the field and target step so we can use them after confirmation
            this.$store.general.pendingEdit = {
                field: field,
                targetStep: this.steps.findIndex(step => step.fields?.includes(field))
            };
            return;
        }

        // If warning was shown once, directly navigate without confirmation
        this.steps.forEach((step, index) => {
            if (step.fields?.includes(field)) {
                this.setStep(index)
                setTimeout(() => {
                    const element =
                        document.querySelector(`[id="error-${field}"]`) ||
                        document.querySelector(`[name="${field}"]`)
                    element?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                    })
                }, 100)
            }
        })
    },
    parseFraction(value) {
        if (this.isNumber(value)) {
            return parseFloat(value)
        }

        const parts = value.replace(/\s+/g, ' ').trim().split(' ')
        let whole = 0

        if (parts.length === 2 && this.isNumber(parts[0])) {
            whole = parseFloat(parts[0])
            parts.shift()
        }

        if (parts.length === 1) {
            const fraction = parts[0].split('/')

            if (
                fraction.length === 2 &&
                this.isNumber(fraction[0]) &&
                this.isNumber(fraction[1])
            ) {
                return whole + parseFloat(fraction[0]) / parseFloat(fraction[1])
            }
        }

        return null
    },
    isNumber(str) {
        return /^\-?[0-9]+(e[0-9]+)?(\.[0-9]+)?$/.test(str)
    },
    objectFilter(obj, callback) {
        return Object.fromEntries(
            Object.entries(obj).filter(entry => {
                return callback(entry[1], entry[0])
            }),
        )
    },
    toFields(fieldIds) {
        return this.objectFilter(this.fields, (field, id) =>
            fieldIds?.includes(id),
        )
    },
    async nextStep() {
        if (this.currentStep === 7) {
            const saved = await this.saveBuild(true)
            if (!saved) return
        }
        if (this.currentStep < this.steps.length) {
            this.setStep(this.currentStep + 1)
        }
    },
    previousStep() {
        if (this.currentStep > 0) {
            this.setStep(this.currentStep - 1)
        }
    },
    setStep(step) {
        if (step < this.currentStep) {
            this.$store.general.warningShownOnce = false;
        }

        // Mark the step we're moving to as visited
        this.steps[step].visited = true;

        window.dispatchEvent(new CustomEvent('gtmdata', {
            detail: {
                event: 'gtm_screw_builder_set_step',
                payload: {
                    currentStep: this.currentStep,
                    nextStep: step,
                }
            },
        }))

        this.currentStep = step;
        this.filterAvailableFields();

        this.$refs.fieldArea.scrollTop = 0;

        this.$refs.stepList.children[step].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
        });

        this.$refs.stepListMobile.children[step].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
        });
    },
    changeQuantity(amount = 1) {
        if (!this.fields.quantity.value) {
            this.fields.quantity.value = 1
        }
        let iterations = 0
        clearTimeout(this.heldTimeout)
        this.heldTimeout = null

        const checkButtonHeld = () => {
            this.fields.quantity.value = Math.max(
                1,
                (this.fields.quantity.value += amount),
            )
            const delay = 1500 / (iterations + 3)
            iterations += 1

            this.heldTimeout = setTimeout(() => {
                if (this.buttonHeld) {
                    checkButtonHeld()
                }
            }, delay)
        }

        checkButtonHeld()
    },

    async saveBuild(enquiry = false, email = '') {
        let request = {
            build: {},
            enquiry: {},
        }

        for (let fieldId in this.fields) {
            const field = this.fields[fieldId]
            if (field.value) {
                request[field.section || 'build'][fieldId] = field.value
            }
        }

        if (this.build.id) {
            request.build.id = this.build.id
        }

        if (!enquiry) {
            delete request.enquiry
        }

        if (email) {
            request.email = email
        }

        this.saving = true

        try {
            const response = await window.api.post(
                '/screw-builder?action=save',
                request,
            )

            if (enquiry) {
                window.dispatchEvent(new CustomEvent('gtmdata', {
                    detail: {
                        event: 'gtm_screw_builder_submit',
                    },
                }))
            }

            this.saving = false
            return response.data
        } catch (error) {
            if (error.response.data.errors) {
                for (let field in error.response.data.errors) {
                    this.fields[field].error =
                        error.response.data.errors[field].join(', ')
                }
                this.editField(Object.keys(error.response.data.errors)[0])
            }
            if (error.response.data.message) {
                window.dispatchEvent(
                    new CustomEvent('create-toast', {
                        detail: {
                            title: 'We encountered a problem...',
                            message: error.response.data.message,
                            type: 'error',
                        },
                    }),
                )
            }

            this.saving = false
            return false
        }
    },

    async copyBuildLink() {
        // try {
        const response = await this.saveBuild()
        const url = response.data.build_url
        navigator.clipboard.writeText(url)
        window.dispatchEvent(
            new CustomEvent('create-toast', {
                detail: {
                    title: 'Copied to clipboard',
                    message: url,
                    type: 'success',
                },
            }),
        )

        window.dispatchEvent(new CustomEvent('gtmdata', {
            detail: {
                event: 'gtm_screw_builder_save_copy',
                payload: {
                    currentStep: this.currentStep,
                }
            },
        }))
        // }
        // catch (error) {
        //     let message = 'Could not copy link'

        //     if (error.response?.data?.message) {
        //         message = error.response.data.message
        //     }

        //     window.dispatchEvent(new CustomEvent('create-toast', {
        //         detail: {
        //             title: 'We encountered a problem...',
        //             message: error,
        //             type: 'error',
        //         },
        //     }))
        // }
    },

    sendSaveBuildEmail(email) {
        const data = this.saveBuild(false, email)
        if (data) {
            window.dispatchEvent(
                new CustomEvent('create-toast', {
                    detail: {
                        title: 'Email sent',
                        message: 'Your build has been sent to ' + email,
                        type: 'success',
                    },
                }),
            )
        }

        window.dispatchEvent(new CustomEvent('gtmdata', {
            detail: {
                event: 'gtm_screw_builder_save_email',
                payload: {
                    currentStep: this.currentStep,
                }
            },
        }))
    },

    async getBuild(buildId) {
        try {
            const url = new URL('/screw-builder/', window.location.origin)
            url.searchParams.append('action', 'get-build')

            if (buildId) {
                url.searchParams.append('build_id', buildId)
            }

            const response = await window.api.post(url.toString())

            this.build = response.data.data.build

            Object.entries(this.build).forEach(([key, value]) => {
                if (this.fields[key]) {
                    this.fields[key].value = value
                }
            })

            const step = Math.max(
                0,
                this.steps.findIndex(
                    step =>
                        !step.fields?.some(field => this.fields[field].value),
                ) - 1,
            )

            if (step != 0) {
                this.setStep(step)
                this.started = true
            }

            window.dispatchEvent(new CustomEvent('gtmdata', {
                detail: {
                    event: 'gtm_screw_builder_load_build',
                    payload: {
                        buildId: buildId,
                    }
                },
            }))
        } catch (error) {
            console.log(error)
        }
    },
})
